// Shared cell ID format used by Cell.tsx (to set the HTML id attribute) and
// any component that constructs cell IDs for aria-labelledby references.
// This format is also part of the external API for onboarding tours and
// coaching tips — do not change without updating those consumers.
export const getCellExternalId = (columnNamespace, columnName, rowId) => `cell-${columnNamespace}-${columnName}-${rowId}`;

// Derives the content wrapper id from a cell's id. The content wrapper is
// CSSHoverCell's ChildrenWrapper — it contains only the primary display text
// (e.g. the contact name), excluding hover actions like "Preview".
// Used by:
//   - CSSHoverCell to set the ChildrenWrapper's id attribute
//   - SelectRowCheckboxCell's aria-labelledby to reference the row's label
export const toContentId = cellId => `${cellId}-content`;

// Convenience shorthand: computes the content wrapper id directly from
// column namespace, column name, and row id.
export const getCellContentId = (columnNamespace, columnName, rowId) => toContentId(getCellExternalId(columnNamespace, columnName, rowId));